var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import "./index.css";
import { NotSelected } from "./NotSelected";
import { Selected } from "./Selected";
export const PreviewPlayer = (_a) => {
    var { layoutItem, scale, isSelected, screenWidth } = _a, rest = __rest(_a, ["layoutItem", "scale", "isSelected", "screenWidth"]);
    const textData = layoutItem.widget.data;
    return isSelected ? (React.createElement(Selected, Object.assign({ textData: textData, scale: scale, layoutItem: layoutItem, isSelected: isSelected, screenWidth: screenWidth }, rest))) : (React.createElement(NotSelected, { text: textData.text, scale: scale, bgColor: textData.backgroundColor }));
};
